import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import SketchPicker from 'react-color';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Card } from '@mui/material';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, GetCarriersColors, SaveCarrierColor, ToggleCarriersColorsPickerDialog, ToggleCarriersColorsDialog
} from '../../../actions/DualMapActionsGeneric';

const useStyles = makeStyles((theme) => ({
	contentSection: {
		padding: theme.spacing(2, 0),
	},
}));

const CarriersColorsPickerDialog = (props) => {
	const { author, open, onClose, onApply, className, currentColorCode, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const tableIdColorCode = useSelector((state) => state.dualMapReducer.tableIdColorCode);

	// const getData = useCallback(() => {
	// 	dispatch(GetCarriersColors());
	// }, []);

	// useEffect(() => {
	// 	getData();
	// }, []);

	const [color, setColor] = useState(currentColorCode === null ? 'white' : currentColorCode);

	const handleChangeComplete = (selectedColor) => {
		setColor(selectedColor.hex);
	};

	const _onConfirmClick = () => {
		dispatch(SaveCarrierColor(userId, tableIdColorCode, color));
		dispatch(ToggleCarriersColorsPickerDialog(false));
		dispatch(ToggleCarriersColorsDialog(true));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Color Picker"
			cancelLabel="Close"
			confirmLabel="Save"
			onConfirmClicked={_onConfirmClick}
			style={{ width: '30vw !important' }}
		>
			<Card>
				<div className={classes.content}>
					<div className={classes.contentSection}>
						<Grid container spacing={1}>
							<Grid
								container
								spacing={0}
								direction="column"
								alignItems="center"
								justify="center"
							>
								<SketchPicker
									color={color}
									onChangeComplete={handleChangeComplete}
								/>
							</Grid>
						</Grid>
					</div>
				</div>
			</Card>
		</ModalDialog>
	);
};

CarriersColorsPickerDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	currentColorCode: PropTypes.string
};

export default CarriersColorsPickerDialog;
